import {
  timeScalarOrEmptyToEpochMs,
  type TimeScalar,
} from '@bts-web/utils-formatting';

export const MINIMUM_REFRESH_TIME = 5000;

export const getOfferAvailabilityInMs = (
  expiresAt: TimeScalar | null | undefined,
) => {
  const nextExpiresAtInMs = timeScalarOrEmptyToEpochMs(expiresAt);

  if (!Number.isFinite(nextExpiresAtInMs)) return MINIMUM_REFRESH_TIME;

  const currentTimeInMs = Date.now();

  const newValue = nextExpiresAtInMs - currentTimeInMs;

  return Math.max(newValue, MINIMUM_REFRESH_TIME);
};
